import { buildPrintHtml, PAPER_MM, printMargins } from './print.js';
/** 순수: JPEG 쪽 이미지들 → PDF 바이트 (쪽 크기 pt) */
export function buildImagePdf(pages, pageWpt, pageHpt) {
    const enc = new TextEncoder();
    const chunks = [];
    let len = 0;
    const put = (x) => { const b = typeof x === 'string' ? enc.encode(x) : x; chunks.push(b); len += b.length; };
    const offs = [];
    const begin = (n) => { offs[n] = len; put(`${n} 0 obj\n`); };
    const W = pageWpt.toFixed(2), H = pageHpt.toFixed(2);
    put('%PDF-1.4\n%âãÏÓ\n');
    begin(1);
    put('<< /Type /Catalog /Pages 2 0 R >>\nendobj\n');
    begin(2);
    put(`<< /Type /Pages /Kids [${pages.map((_, i) => `${3 + i * 3} 0 R`).join(' ')}] /Count ${pages.length} >>\nendobj\n`);
    pages.forEach((p, i) => {
        const pg = 3 + i * 3, ct = pg + 1, im = pg + 2;
        begin(pg);
        put(`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${W} ${H}] /Resources << /XObject << /Im0 ${im} 0 R >> >> /Contents ${ct} 0 R >>\nendobj\n`);
        const cs = `q ${W} 0 0 ${H} 0 0 cm /Im0 Do Q\n`;
        begin(ct);
        put(`<< /Length ${enc.encode(cs).length} >>\nstream\n${cs}endstream\nendobj\n`);
        begin(im);
        put(`<< /Type /XObject /Subtype /Image /Width ${p.width} /Height ${p.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${p.jpeg.length} >>\nstream\n`);
        put(p.jpeg);
        put('\nendstream\nendobj\n');
    });
    const n = 3 + pages.length * 3;
    const xref = len;
    put(`xref\n0 ${n}\n0000000000 65535 f \n`);
    for (let k = 1; k < n; k++)
        put(`${String(offs[k]).padStart(10, '0')} 00000 n \n`);
    put(`trailer\n<< /Size ${n} /Root 1 0 R >>\nstartxref\n${xref}\n%%EOF\n`);
    const out = new Uint8Array(len);
    let o = 0;
    for (const c of chunks) {
        out.set(c, o);
        o += c.length;
    }
    return out;
}
/** 그리드 → PDF 바이트·쪽 수 (브라우저 전용) */
export async function gridToPdf(grid, o = {}) {
    const html = buildPrintHtml(grid, o).replace(/zoom: [\d.]+;/, '');
    const [pw0, ph0] = PAPER_MM[o.paper && o.paper in PAPER_MM ? o.paper : 'A4'];
    const land = o.orientation === 'landscape';
    const pw = land ? ph0 : pw0, ph = land ? pw0 : ph0;
    const mg = printMargins(typeof o.margin === 'number' || typeof o.margin === 'object' ? o.margin : undefined);
    const sc = Math.max(0.1, (Number(o.scale) || 100) / 100);
    const MM = 96 / 25.4;
    const cw = (pw - mg.left - mg.right) * MM, ch = (ph - mg.top - mg.bottom) * MM;
    const lw = cw / sc, avail = ch / sc - 2;
    const f = document.createElement('iframe');
    f.setAttribute('aria-hidden', 'true');
    f.tabIndex = -1;
    f.style.cssText = `position:fixed;left:-20000px;top:0;width:${lw}px;height:${Math.ceil(avail)}px;border:0;visibility:hidden`;
    document.body.appendChild(f);
    try {
        const doc = f.contentDocument;
        doc.open();
        doc.write(html);
        doc.close();
        await doc.fonts?.ready;
        const body = doc.body;
        const styleText = [...doc.querySelectorAll('style')].map(s => s.textContent ?? '').join('\n')
            .replace(/@page\s*\{[\s\S]*?\}\s*\}/, '').replace(/\bhtml\s*\{/g, '.pbody {').replace(/\bbody\s*\{/g, '.pbody {');
        // ── 쪽 나누기 ──
        const pages = [{ items: [], used: 0 }];
        const cur = () => pages[pages.length - 1];
        const newPage = () => { pages.push({ items: [], used: 0 }); };
        const outerH = (el) => { const cs = doc.defaultView.getComputedStyle(el); return el.getBoundingClientRect().height + (parseFloat(cs.marginTop) || 0) + (parseFloat(cs.marginBottom) || 0); };
        for (const el of [...body.children]) {
            if (el.classList.contains('wm') || el.tagName === 'SCRIPT' || el.tagName === 'STYLE')
                continue;
            const brk = el.dataset?.break === '1';
            if (brk && cur().items.length)
                newPage();
            if (!(el instanceof doc.defaultView.HTMLTableElement) || !el.classList.contains('g')) {
                const h = outerH(el);
                if (h === 0)
                    continue;
                if (cur().used + h > avail && cur().items.length)
                    newPage();
                cur().items.push({ el });
                cur().used += h;
                continue;
            }
            const t = el;
            const headH = t.tHead?.getBoundingClientRect().height ?? 0;
            const footH = t.tFoot?.getBoundingClientRect().height ?? 0;
            const rows = [...t.tBodies].flatMap(b => [...b.rows]);
            const st = { chunk: null };
            const start = () => { const c = { table: t, rows: [], foot: false }; st.chunk = c; cur().items.push(c); cur().used += headH + 1; return c; };
            for (const tr of rows) {
                const h = tr.getBoundingClientRect().height;
                let c = st.chunk;
                if (!c) {
                    if (cur().used + headH + h > avail && cur().items.length)
                        newPage();
                    c = start();
                }
                else if (cur().used + h > avail && c.rows.length) {
                    newPage();
                    c = start();
                }
                c.rows.push(tr);
                cur().used += h;
            }
            let c = st.chunk ?? (cur().used + headH + footH > avail && cur().items.length ? (newPage(), start()) : start());
            if (footH) {
                if (cur().used + footH > avail) {
                    newPage();
                    c = start();
                }
                c.foot = true;
                cur().used += footH;
            }
        }
        if (!pages[pages.length - 1].items.length && pages.length > 1)
            pages.pop();
        // ── 쪽 그리기 ──
        const dpi = Math.min(300, Math.max(72, Number(o.dpi) || 144)), k = dpi / 96;
        const W = Math.round(pw * MM * k), H = Math.round(ph * MM * k);
        const canvas = document.createElement('canvas');
        canvas.width = W;
        canvas.height = H;
        const ctx = canvas.getContext('2d');
        const wm = o.watermark ? body.querySelector('.wm') : null;
        const now = new Date(), p2 = (x) => String(x).padStart(2, '0');
        const stamp = `${now.getFullYear()}-${p2(now.getMonth() + 1)}-${p2(now.getDate())} ${p2(now.getHours())}:${p2(now.getMinutes())}`;
        const out = [];
        for (let i = 0; i < pages.length; i++) {
            const pb = doc.createElement('div');
            pb.className = 'pbody';
            pb.setAttribute('style', `position:relative;width:${lw}px;height:${avail}px;overflow:hidden;background:#fff`);
            if (wm) {
                const w = wm.cloneNode(true);
                w.style.position = 'absolute';
                pb.appendChild(w);
            }
            for (const it of pages[i].items) {
                if ('el' in it) {
                    pb.appendChild(it.el.cloneNode(true));
                    continue;
                }
                const t = it.table.cloneNode(false);
                const cg = it.table.querySelector('colgroup');
                if (cg)
                    t.appendChild(cg.cloneNode(true));
                if (it.table.tHead)
                    t.appendChild(it.table.tHead.cloneNode(true));
                const tb = doc.createElement('tbody');
                for (const r of it.rows)
                    tb.appendChild(r.cloneNode(true));
                t.appendChild(tb);
                if (it.foot && it.table.tFoot)
                    t.appendChild(it.table.tFoot.cloneNode(true));
                pb.appendChild(t);
            }
            const st = doc.createElement('style');
            st.textContent = styleText;
            pb.insertBefore(st, pb.firstChild);
            const xhtml = new XMLSerializer().serializeToString(pb);
            const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${lw}" height="${avail}"><foreignObject x="0" y="0" width="100%" height="100%">${xhtml}</foreignObject></svg>`;
            const img = new Image();
            img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
            await img.decode();
            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, W, H);
            ctx.drawImage(img, mg.left * MM * k, mg.top * MM * k, cw * k, avail * sc * k);
            // 머리말·꼬리말 (인쇄의 @page 상자와 같은 내용)
            ctx.fillStyle = '#555';
            ctx.font = `${(8 * 4 / 3) * k}px "Malgun Gothic", "Apple SD Gothic Neo", sans-serif`;
            ctx.textBaseline = 'middle';
            const fy = (ph - mg.bottom / 2) * MM * k;
            ctx.textAlign = 'left';
            if (o.footerLeft)
                ctx.fillText(o.footerLeft, mg.left * MM * k, fy);
            ctx.textAlign = 'center';
            ctx.fillText(`${o.footerText ? o.footerText + '  ·  ' : ''}${i + 1} / ${pages.length}`, W / 2, fy);
            if (o.headerText)
                ctx.fillText(o.headerText, W / 2, (mg.top / 2) * MM * k);
            ctx.textAlign = 'right';
            ctx.fillText(`출력 ${stamp}`, (pw - mg.right) * MM * k, fy);
            const blob = await new Promise((res, rej) => canvas.toBlob(b => (b ? res(b) : rej(new Error('JPEG 변환 실패'))), 'image/jpeg', Math.min(1, Math.max(0.3, Number(o.quality) || 0.85))));
            out.push({ jpeg: new Uint8Array(await blob.arrayBuffer()), width: W, height: H });
        }
        return { pdf: buildImagePdf(out, pw * 72 / 25.4, ph * 72 / 25.4), pages: out.length };
    }
    finally {
        f.remove();
    }
}
